<template>

    <div>

        <vue-swing v-show="step === ENUM.STEPS.TUTO.UNSUBSCRIBES"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutleft="$emit('next')"
                   :config="configUnsubscribes">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>


        <vue-swing v-show="step === ENUM.STEPS.TUTO.DELETE"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutup="$emit('next')"
                   :config="configDelete">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>


        <vue-swing v-show="step === ENUM.STEPS.TUTO.KEEP"
                   class="tuto-cards__swing"
                   ref="vueSwing"
                   @throwoutright="$emit('next')"
                   :config="configKeep">
            <img :src="cardImage" class="tuto-cards">
        </vue-swing>

    </div>

</template>

<script>
import VueSwing from 'vue-swing'

import ENUM from '@/assets/ENUM'

export default {

    name: 'tuto-cards',

    props: {
        step: {
            type: String,
            default: ''
        }
    },

    components: {
        VueSwing
    },

    computed: {

        ENUM() {
            return ENUM
        },

        cardImage() {

            switch (this.step) {
                case ENUM.STEPS.TUTO.UNSUBSCRIBES:
                    return '/img/newsletters-v2/card-unsubscribes.svg'
                case ENUM.STEPS.TUTO.DELETE:
                    return '/img/newsletters-v2/card-delete.svg'
                case ENUM.STEPS.TUTO.KEEP:
                    return '/img/newsletters-v2/card-keep.svg'
            }
        },

        configUnsubscribes() {
            return {
                throwOutConfidence: this.throwOutConfidence,
                allowedDirections: [VueSwing.Direction.LEFT]
            }
        },

        configDelete() {
            return {
                throwOutConfidence: this.throwOutConfidence,
                allowedDirections: [VueSwing.Direction.UP]
            }
        },

        configKeep() {
            return {
                throwOutConfidence: this.throwOutConfidence,
                allowedDirections: [VueSwing.Direction.RIGHT]
            }
        }
    },

    data() {
        return {
            throwOutConfidence: (xOffset, yOffset, element) => {
                if (Math.abs(xOffset) > yOffset) {

                    const xConfidence = Math.min(Math.abs(xOffset) / element.offsetWidth, 1)
                    const yConfidence = Math.min(Math.abs(yOffset) / element.offsetHeight, 1)
                    const result = Math.max(xConfidence, yConfidence)
                    return result > 0.5 ? 1 : result
                }
                return 0
            }
        }
    }

}
</script>

<style lang="scss" scoped>

.tuto-cards {
    width: 100%;
    object-fit: contain;

    &__swing {
        display: flex;
        flex-grow: 1;
    }
}
</style>
